import { APPLY_PRESET, IAction, SET_FILTERS } from 'components/Screen';

import {
  COLUMNS,
  DIMENSION,
  FILTERS,
  METRICS,
  OFFSET,
  TABLE_SETTINGS,
  initialState,
} from './constants';

export { SET_FILTERS } from 'components/Screen';

export const SET_METRICS = 'SET_METRICS';
export const SET_TABLE_SETTINGS = 'SET_TABLE_SETTINGS';
export const SET_COLUMNS = 'SET_COLUMNS';
export const SET_DIMENSION = 'SET_DIMENSION';

export default function screenReducer(state: any = {}, action: IAction) {
  switch (action.type) {
    case APPLY_PRESET:
      const { data, id } = action.payload;

      return {
        ...data,
        isFetching: state.isFetching,
        isLoading: state.isLoading,
        presetID: id,
        [TABLE_SETTINGS]: {
          ...state[TABLE_SETTINGS],
          [OFFSET]: initialState[TABLE_SETTINGS][OFFSET],
        },
      };

    case SET_FILTERS:
      return {
        ...state,
        [FILTERS]: action.payload,
        [TABLE_SETTINGS]: {
          ...state[TABLE_SETTINGS],
          [OFFSET]: initialState[TABLE_SETTINGS][OFFSET],
        },
      };
    case SET_COLUMNS:
      return {
        ...state,
        [COLUMNS]: action.payload,
      };
    case SET_DIMENSION:
      return {
        ...state,
        [DIMENSION]: action.payload,
        [TABLE_SETTINGS]: {
          ...state[TABLE_SETTINGS],
          [OFFSET]: initialState[TABLE_SETTINGS][OFFSET],
        },
      };
    case SET_METRICS:
      return {
        ...state,
        [METRICS]: action.payload,
      };
    case SET_TABLE_SETTINGS:
      return {
        ...state,
        [TABLE_SETTINGS]: action.payload,
      };
    default:
      return state;
  }
}
